var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSkiingRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.357 4.062a2.062 2.062 0 1 1 4.125 0 2.062 2.062 0 0 1-4.125 0zM2.116 13.554c.262-.507.885-.7 1.392-.438l8.795 4.567 2.132-3.201-3.554-3.777a2.365 2.365 0 0 1-.649-1.5l3.769 1.805 2.122 2.256c.55.584.623 1.465.18 2.131l-2.156 3.24 5.835 3.029c.584.305 1.28.31 1.873.013l.653-.327a1.033 1.033 0 0 1 1.384.46c.253.507.047 1.13-.46 1.384l-.653.326a4.128 4.128 0 0 1-3.747-.03L2.554 14.946a1.035 1.035 0 0 1-.438-1.392zm4.993-8.735.777.37.374-.748a.693.693 0 0 1 .924-.31c.34.168.477.585.31.924l-.366.726 2.385 1.143c.073-.039.15-.073.232-.107l3.476-1.393a2.402 2.402 0 0 1 3.248 1.75l.529 2.564 2.702 1.294c.516.245.73.859.486 1.375a1.03 1.03 0 0 1-1.375.485l-2.329-1.113a.991.991 0 0 1-.12-.043L8.518 7.01l-.395.79a.693.693 0 0 1-.924.31.691.691 0 0 1-.31-.924l.387-.773-.756-.361a.685.685 0 1 1 .593-1.238l-.004.005zm9.336 2.78a.342.342 0 0 0-.464-.25l-1.963.787 2.814 1.353-.387-1.886v-.004z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSkiingRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-skiing-regular.bb849482.svg";
export { ForwardRef as ReactComponent };